import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { LoginPage } from './features/auth/login/login.page';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        component: LoginPage,
        data: { title: 'Iniciar sesión' },
      },
    ],
  },
  {
    path: 'forgot-password',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password.page').then(
            (m) => m.ForgotPasswordPage,
          ),
        data: { title: 'Recuperar contraseña' },
      },
    ],
  },
  {
    //  change-password permite acceso SIN sesión si hay token (reset password)
    path: 'change-password',
    component: AuthLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/auth/change-password/change-password.page').then(
            (m) => m.ChangePasswordPage,
          ),
        data: { title: 'Cambiar contraseña' },
      },
    ],
  },

  {
    path: '',
    component: LayoutComponent,

    children: [
      {
        path: 'dashboard',
        canActivate: [authGuard],
        data: { title: 'Dashboard', roles: ['GERENTE', 'SUBDIRECCION', 'DIRECCION', 'ADMIN'] },
        loadComponent: () =>
          import('./features/dashboard/pages/dashboard.page').then((m) => m.DashboardPage),
      },
      {
        path: 'kpi/create',
        canActivate: [authGuard],
        data: { title: 'Crear KPI', roles: ['GERENTE', 'SUBDIRECCION', 'DIRECCION', 'ADMIN'] },
        loadComponent: () =>
          import('./features/kpi/pages/create-kpi/create-kpi.page').then((m) => m.CreateKpiPage),
      },
      {
        path: 'kpi/edit/:id',
        canActivate: [authGuard],
        data: { title: 'Editar KPI', roles: ['GERENTE', 'SUBDIRECCION', 'DIRECCION', 'ADMIN'] },
        loadComponent: () =>
          import('./features/kpi/pages/create-kpi/create-kpi.page').then((m) => m.CreateKpiPage),
      },

      {
        path: 'reports',
        canActivate: [authGuard],
        data: { title: 'Reportes KPI', roles: ['GERENTE', 'SUBDIRECCION', 'DIRECCION', 'ADMIN'] },
        loadComponent: () =>
          import('./features/reports/pages/reports.page').then((m) => m.ReportsPage),
      },

      {
        path: 'departments',
        canActivate: [authGuard],
        data: { title: 'Departamentos', roles: ['SUBDIRECCION', 'DIRECCION', 'ADMIN'] },
        loadComponent: () =>
          import('./features/departments/pages/list-departments/list-departments.page').then(
            (m) => m.ListDepartmentsPage,
          ),
      },

      {
        path: 'departments/create',
        canActivate: [authGuard],
        data: {
          title: 'Crear Departamento',
          roles: ['SUBDIRECCION', 'DIRECCION', 'ADMIN'],
        },
        loadComponent: () =>
          import('./features/departments/pages/create-department/create-department.page').then(
            (m) => m.CreateDepartmentPage,
          ),
      },

      {
        path: 'departments/edit/:id',
        canActivate: [authGuard],
        data: {
          title: 'Editar Departamento',
          roles: ['SUBDIRECCION', 'DIRECCION', 'ADMIN'],
        },
        loadComponent: () =>
          import('./features/departments/pages/create-department/create-department.page').then(
            (m) => m.CreateDepartmentPage,
          ),
      },

      {
        path: 'users',
        canActivate: [authGuard],
        data: { title: 'Usuarios', roles: ['ADMIN', 'DIRECCION', 'SUBDIRECCION'] },
        loadComponent: () =>
          import('./features/users/pages/list-users/list-users.page').then((m) => m.ListUsersPage),
      },

      {
        path: 'users/create',
        canActivate: [authGuard],
        data: { title: 'Crear Usuario', roles: ['ADMIN', 'DIRECCION', 'SUBDIRECCION'] },
        loadComponent: () =>
          import('./features/users/pages/create-user/create-user.page').then(
            (m) => m.CreateUserPage,
          ),
      },
      {
        path: 'users/edit/:id',
        canActivate: [authGuard],
        data: { title: 'Editar Usuario', roles: ['ADMIN', 'DIRECCION', 'SUBDIRECCION'] },
        loadComponent: () =>
          import('./features/users/pages/create-user/create-user.page').then(
            (m) => m.CreateUserPage,
          ),
      },

      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
